import React from 'react';

const UserEditForm = ({ formData, errors, handleChange }) => {
  return (
    <div className="admin__modal-column">
      <div className="form-group">
        <input
          type="text"
          name="email"
          value={formData.email}
          placeholder="Email"
          className="readonly-field"
          disabled
        />
      </div>

      <div className="form-group">
        <input
          type="text"
          name="first_name"
          value={formData.first_name}
          onChange={handleChange}
          placeholder="First Name*"
          maxLength="40"
          className={errors.first_name ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.first_name}</p>
        </div>
      </div>

      <div className="form-group">
        <input
          type="text"
          name="last_name"
          value={formData.last_name}
          onChange={handleChange}
          placeholder="Last Name*"
          maxLength="40"
          className={errors.last_name ? 'error' : ''}
        />
        <div className="error-message-container">
          <p className="error-message">{errors.last_name}</p>
        </div>
      </div>

    </div>
  );
};

export default UserEditForm;